<template>
    <Card class="card">
        <count-time ref="child" @childFn="parentFn" class="count"></count-time>
        <div class="title">
            <div class="point">
                <div>知识点：<span v-for="(item,i) in currItemInfo.knowledgePoints" :key="i">{{item.title}}</span></div>
            </div>
        </div>
        <div class="item-num">
            <span :class="[{'activeIndex':currIndex===i}]" v-for="(item,i) in questionIds.length" :key="i" @click="toggleQuestion(i)">{{item}}</span>
        </div>
        <div class="item-detail">
            <div v-if="flag">
                <questionSingle v-if="currItemInfo.questionType === 1" :info='currItemInfo' @childQuestionFn="pSigleFn"></questionSingle>
            </div>
            <div v-if="flag">
                <questionMultiple v-if="currItemInfo.questionType === 2" :info='currItemInfo' @childQuestionFn="pMultipleFn"></questionMultiple>
            </div>
            <div v-if="flag">
                <questionJugle v-if="currItemInfo.questionType === 3" :info='currItemInfo' :jugleAnswer="currItemInfo.yourAnswer" @childQuestionFn="pJugleFnFn"></questionJugle>
            </div>
            <div v-if="flag">
                <questionFillBlank v-if="currItemInfo.questionType === 4" :info='currItemInfo' :answerCount="currItemInfo.answerCount*1"  @childQuestionFn="pFillFn"></questionFillBlank>
            </div>
            <!-- <questionSubject v-if="currItemInfo.questionType === 5" :info='currItemInfo' @childQuestionFn="pSubjectFn"></questionSubject> -->
            <div v-if="currItemInfo.questionType === 6">
                <div class="scratchIframe" style="height:700px" v-if="isShowScratch">
                    <iframe id="iframe" src="/scratch-gui/" frameBorder="0" width="100%" height="100%" scrolling="auto"></iframe>
                </div>
            </div>
        </div>
        <div class="item-footer">
            <Button type="primary" :disabled="prevStatus" @click="prev(currQuestionId, currItemInfo.questionType)">上一题</Button>
            <Button type="primary" v-if="!nextStatus" @click="next(currQuestionId, currItemInfo.questionType)">下一题</Button>
            <Button type="primary" v-else @click="handleEndTest">交卷并查看结果</Button>
            <!-- <Button type="primary" :loading="submitLoading" @click="submit(currQuestionId, currItemInfo.questionType)">提交答案</Button> -->
        </div>
        <!-- 答题结果   :mask-closable="false"-->
        <Modal v-model="showResultModal" class="knowModal resultModal" @on-cancel="offResultModal" width="800" :closable="false" :z-index="9999">
            <div class="re-title">练习结果</div>
            <div class="re-counts">
                <div>总题数：{{questionIds.length}}题</div>
                <!-- <div>已做：2题</div> -->
                <div>正确：{{rightCounts}}题</div>
            </div>
            <div class="re-num">
                <span v-for="(item,i) in currInfo.testCount" :key="i">{{item}}</span>
            </div>
            <div class="right-rate">
                <div>正确率</div>
                <div>{{rightRate}}</div>
                <div>耗时：{{timeSpend}}</div>
            </div>
            <div v-if="showResultModal">
                <div class="item-detail" v-for="(item,i) in quesAnswerList" :key="i">
                    <questionSingleView v-if="item.questionType === 1" :info='item' :status='item.rightStatus' :correctAnswer='item.answer' :yourAnswer="item.yourAnswer" :txtSolution='item.txtSolution' :videoSolution='item.videoSolution' ></questionSingleView>
                    <questionMultipleView v-if="item.questionType === 2" :info='item' :status='item.rightStatus' :correctAnswer='item.answer' :yourAnswer="item.yourAnswer" :txtSolution='item.txtSolution' :videoSolution='item.videoSolution'></questionMultipleView>
                    <questionJugleView v-if="item.questionType === 3" :info='item' :status='item.rightStatus'  :correctAnswer='corrextAnswer' :yourAnswer="item.yourAnswer" :txtSolution='item.txtSolution' :videoSolution='item.videoSolution'></questionJugleView>
                    <questionFillBlankView  v-if="item.questionType === 4" :info='item' :status='item.rightStatus' :correctAnswer='item.rightAnswers' :yourAnswer="item.yourAnswer" :txtSolution='item.txtSolution' :videoSolution='item.videoSolution'></questionFillBlankView>
                    <div v-if="item.questionType === 6">编程</div>
                </div>
            </div>
        </Modal>
    </Card>
</template>
<script>
import countTime from './components/countTime.vue'
import questionSingle from './components/questionSingle.vue'
import questionSingleView from './components/questionSingleView.vue'
import questionMultiple from './components/questionMultiple.vue'
import questionMultipleView from './components/questionMultipleView.vue'
import questionJugle from './components/questionJugle.vue'
import questionJugleView from './components/questionJugleView.vue'
// import questionSubject from './components/questionSubject.vue'
import questionFillBlank from './components/questionFillBlank.vue'
import questionFillBlankView from './components/questionFillBlankView.vue'
import util from '@/libs/util'
export default {
  components: { countTime, questionSingle, questionMultiple, questionJugle,  questionFillBlank, questionSingleView, questionMultipleView, questionJugleView, questionFillBlankView },
    data(){
        return{
            flag:false,

            batchId: '',
            questionIds: [],
            currQuestionId: '',
            startTime: 0,
            prevStatus: false,
            nextStatus: false,
            currIndex: 0,
            isNext: false,
            singleAnwer: '',
            multipleAnswer: '',
            jugleAnswer: '',
            fillAnswer: '',
            subjectAnswer: '',
            corrextAnswer: '',
            yourAnswer: '',//所填答案
            quesAnswerList: [],
            rightRate: 0,
            yourAnswerList: [],
            nexTxt: '下一题',
            rightCounts: 0,
            
            
            submitLoading: false,
            showResolutionBox:false,
            showResultModal: false,
            resolveModal: false,
            currInfo: {},
            timeSpend:'2分3秒',
            currItemInfo: {},// 当前题目信息
            currResolution:'',
            childTimeInfo: {},
            ossPath: '',
            events: {
                receiveMessageFromParent: async function(event) {
                if (document.getElementById('iframe')) {
                    var ifwind = document.getElementById('iframe').contentWindow
                    switch (event.data.DYType) {
                    case 'menuOk':
                        var postData = {
                            DYType: 'opusData',
                            DYOpusData: { materialPath: this.$vue.ossPath },
                            DYShowScoreButton: false,
                            DYShowSaveButton: false,
                            DYIsDesktop: false,
                            DYFrom: 'xbz',
                            DYCanManageFiles: false,
                            DYShowSubmitButton: false
                        }
                        ifwind.postMessage(postData, '*')
                        break
                    case 'getDownToken':
                        let dirPath = event.data.DyDirPath
                        
                        const postData = {
                            DYType: 'aliStsData',
                            downLoadUrl: this.$vue.ossPath,
                            DYLoadType: event.data.DYLoadType
                        }
                        ifwind.postMessage(postData, '*')
                        break
                    case 'nextGo':
                        // console.log("做题成功");
                        this.$vue._handleSuccess()
                        break
                    }
                }
                },
                initScore: 0,
                score: 0,
                DyOssPath: '',
                showScoreButton: false,
                DYShowSaveButton: false
            },
            userInfo: {},
            rightAnswers: '',
            isShowScratch: false,
            isChoosePrev: false,
            fillStatus:false
        }
    },
    created(){
        let info = util.localGet('questionIds')
        this.userInfo = util.localGet('userInfo')
        this.batchId = info.batchId
        this.questionIds = JSON.parse(info.questionIds)
        this.currQuestionId = this.questionIds[0]
        let index = this.questionIds.findIndex((value, index, arr) => {
            return value === this.currQuestionId
        })
        this.prevStatus = true
        this.nextStatus = this.questionIds[index+1] ? false : true
        this._getQuestionDetails(this.currQuestionId)

    },
    mounted(){
        this.$refs.child.$emit('childcounttime')
        this.startTime = Date.parse(new Date())
         window['$vue'] = this
        window.addEventListener('message', this.events.receiveMessageFromParent, false)
    },
    beforeDestroy() {
        window.removeEventListener('message', this.events.receiveMessageFromParent, false)
    },
    methods: {
        // 获取习题详情
        async _getQuestionDetails(id){
            this.flag = true
            let params = {
                id: id,
                userId: this.userInfo.id || '',
                userName: this.userInfo.username || '',
            }
            util.md5Encryption(params)
            const res= await this.postTKRequest('/v1/getQuestionDetails', params, true)
            if(res.success){
                switch (res.result.questionType) {
                    case 1 :// 单选题
                        res.result.optionsA = decodeURIComponent(res.result.optionsA)
                        res.result.optionsB = decodeURIComponent(res.result.optionsB)
                        res.result.optionsC = decodeURIComponent(res.result.optionsC)
                        if(res.result.optionsD){
                            res.result.optionsD = decodeURIComponent(res.result.optionsD)
                        }
                        if(res.result.optionsE){
                            res.result.optionsE = decodeURIComponent(res.result.optionsE)
                        }
                        if(res.result.optionsF){
                            res.result.optionsF = decodeURIComponent(res.result.optionsF)
                        }
                        this.corrextAnswer = decodeURIComponent(res.result.answer)
                    break;
                    case 2:// 多选题
                        res.result.optionsA = decodeURIComponent(res.result.optionsA)
                        res.result.optionsB = decodeURIComponent(res.result.optionsB)
                        res.result.optionsC = decodeURIComponent(res.result.optionsC)
                        if(res.result.optionsD){
                            res.result.optionsD = decodeURIComponent(res.result.optionsD)
                        }
                        if(res.result.optionsE){
                            res.result.optionsE = decodeURIComponent(res.result.optionsE)
                        }
                        if(res.result.optionsF){
                            res.result.optionsF = decodeURIComponent(res.result.optionsF)
                        }
                        this.corrextAnswer = decodeURIComponent(res.result.answer)
                    break;
                    case 3://判断题
                        if(res.result.answer=='对' || res.result.answer=='T'){
                            this.corrextAnswer = 'A'
                            res.result.rightAnswer = 'A'
                        }else if(res.result.answer=='错' || res.result.answer=='F'){
                            this.corrextAnswer = 'B'
                            res.result.rightAnswer = 'B'
                        }
                        break;
                    
                    case 4:// 填空
                        if(res.result.answerCount=='1'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answer = res.result.answerA
                            this.corrextAnswer = res.result.answerA
                        }else if(res.result.answerCount=='2'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            this.corrextAnswer = res.result.answerA + '&' + res.result.answerB
                            res.result.answer = res.result.answerA + ',' + res.result.answerB
                        }else if(res.result.answerCount=='3'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answerC = decodeURIComponent(res.result.answerC)
                            this.corrextAnswer = res.result.answerA + '&' + res.result.answerB + '&' + res.result.answerC
                            res.result.answer = res.result.answerA + ',' + res.result.answerB + ',' + res.result.answerC
                        }else if(res.result.answerCount=='4'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answerC = decodeURIComponent(res.result.answerC)
                            res.result.answerD = decodeURIComponent(res.result.answerD)
                            this.corrextAnswer = res.result.answerA + '&' + res.result.answerB + '&' + res.result.answerC + '&' + res.result.answerD
                            res.result.answer = res.result.answerA + ',' + res.result.answerB + ',' + res.result.answerC + ',' + res.result.answerD
                        }else if(res.result.answerCount=='5'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answerC = decodeURIComponent(res.result.answerC)
                            res.result.answerD = decodeURIComponent(res.result.answerD)
                            res.result.answerE = decodeURIComponent(res.result.answerE)
                            this.corrextAnswer = res.result.answerA + '&' + res.result.answerB + '&' + res.result.answerC + '&' + res.result.answerD + '&' + res.result.answerE
                            res.result.answer = res.result.answerA + ',' + res.result.answerB + ',' + res.result.answerC + ',' + res.result.answerD + ',' + res.result.answerE
                        }
                    break;
                    case 5 || 6:
                        this.corrextAnswer = decodeURIComponent(res.result.answer)
                        break;
                    case 6:
                        if (res.result.programmingType === 1 || 0) {
                            this.ossPath = res.result.programmingPath
                            this.isShowScratch = true
                        } 
                    break;
                }
                res.result.title = decodeURIComponent(res.result.title)
                this.currItemInfo = res.result
                this.currQuestionId = res.result.id
                if(res.result.txtSolution){
                    res.result.txtSolution = decodeURIComponent(res.result.txtSolution)
                }
                let idx = this.quesAnswerList.findIndex((value, index, arr) => {
                    return value.id === this.currItemInfo.id
                })




                //1、获取下一题题号
                //2、获取题目详情
                //3.1、判断questionAnswerList是否存在题目（避免覆盖插入多个相同的question）
                //3.2、res.data push questionAnswerList
                if(idx == -1){
                    this.quesAnswerList.push(res.result)
                }

                let index = this.questionIds.findIndex((value, index, arr) => {
                    return value === id
                })

                if(this.quesAnswerList[index] && this.quesAnswerList[index].yourAnswer){
                    this.currItemInfo.yourAnswer = this.quesAnswerList[index].yourAnswer
                }
            }
        },
        pSigleFn(data){
            let index = this.quesAnswerList.findIndex((value, index, arr) => {
                return value.id === data.questionId
            })
            this.quesAnswerList[index].yourAnswer = data.answer
            this.quesAnswerList[index].rightStatus = data.answer == this.quesAnswerList[index].answer ? 1 : -1
            // this.quesAnswerList[index].scoreValue = this.quesAnswerList[index].rightStatus=='1' ? this.quesAnswerList[index].score : 0
            this.yourAnswer = data
            
        },
        pMultipleFn(data){
            let index = this.quesAnswerList.findIndex((value, index, arr) => {
                return value.id === data.questionId
            })
            this.quesAnswerList[index].yourAnswer = data.answer.sort()
            this.quesAnswerList[index].rightStatus = data.answer == this.quesAnswerList[index].answer ? 1 : -1
            this.yourAnswer = data
        },
        pJugleFnFn(data){
            
            let index = this.quesAnswerList.findIndex((value, index, arr) => {
                return value.id === data.questionId
            })
            this.quesAnswerList[index].yourAnswer = data.answer
            this.quesAnswerList[index].rightStatus = data.answer == this.corrextAnswer ? 1 : -1
            this.yourAnswer = data
        },
        pSubjectFn(data){
            console.log(data,'主观题答案')
            this.yourAnswer = data
        },
        pFillFn(data){
            let index = this.quesAnswerList.findIndex((value, index, arr) => {
                return value.id === data.questionId
            })
            let fillData = this.quesAnswerList[index]
            let rightData = []
            fillData.yourAnswer = data.answer
            switch (data.anserCount) {
                case 1:
                    fillData.rightStatus = data.answer.join(',').trim() == fillData.answerA ? 1 : -1
                    rightData.push(fillData.answerA)
                    fillData.rightAnswers = rightData
                    break;
                case 2:
                    rightData = []
                    fillData.rightStatus = (data.answer[0].trim() == fillData.answerA && data.answer[1] && data.answer[1].trim() ==fillData.answerB) ? 1 : -1
                    rightData.push(fillData.answerA,fillData.answerB)
                    fillData.rightAnswers = rightData
                    break;
                case 3:
                    fillData.rightStatus = (data.answer[0].trim() == fillData.answerA && data.answer[1] && data.answer[1].trim() ==fillData.answerB  && data.answer[2] && data.answer[2].trim() ==fillData.answerC) ? 1 : -1
                    rightData.push(fillData.answerA, fillData.answerB, fillData.answerC)
                    fillData.rightAnswers = rightData
                    break;
                case 4:
                    fillData.rightStatus = (data.answer[0].trim() == fillData.answerA && data.answer[1] && data.answer[1].trim() ==fillData.answerB  && data.answer[2] && data.answer[2].trim() ==fillData.answerC  && data.answer[3] && data.answer[3].trim() ==fillData.answerD) ? 1 : -1
                    rightData.push(fillData.answerA, fillData.answerB, fillData.answerC, fillData.answerD)
                    fillData.rightAnswers = rightData
                    break;
                case 5:
                    fillData.rightStatus = (data.answer[0].trim() == fillData.answerA && data.answer[1] && data.answer[1].trim() ==fillData.answerB  && data.answer[2] && data.answer[2].trim() ==fillData.answerC  && data.answer[3] && data.answer[3].trim() ==fillData.answerD  && data.answer[4] && data.answer[4].trim() ==fillData.answerE) ? 1 : -1
                    rightData.push(fillData.answerA, fillData.answerB, fillData.answerC, fillData.answerD, fillData.answerE)
                    fillData.rightAnswers = rightData
                    break;
                    
                
            }
            this.fillStatus = true
            this.yourAnswer = data
        },
        prev(id, type){
            this.nextStatus = false
            let index = this.questionIds.findIndex((value, index, arr) => {
                return value === id
            })
            if(index>0){
                this.currIndex = parseInt(index - 1)
                if( this.questionIds[index-1]){
                    this.currQuestionId = this.questionIds[index-1]
                    this._getQuestionDetails(this.currQuestionId)
                }
            }
            if(!this.questionIds[index-2]) {
                this.prevStatus = true
            }
        },
        toggleQuestion( toindex ){
            //1、获取当前点击的题号
            //2、当前题号-1 计算出questionAnswerList索引
            const fromindex = this.currIndex
            const fromQuestion = this.quesAnswerList[fromindex];
            const toQuestion = this.quesAnswerList[toindex];

            if(!fromQuestion.yourAnswer ){// 如点击的没有输入答案
                if(toindex < fromindex){//且点击的是上一题
                    this.currItemInfo = toQuestion
                    this.currIndex = toindex
                    this.prevStatus = (toindex==0 ? true : false)
                    this.nextStatus = (toindex==this.questionIds.length-1 ? true : false)
                }else{// 且点击的是下一题
                    this.$Message.info('请先选择或填写答案')
                    return false
                }
            }else{//如果输入了答案
                this.prevStatus = (toindex==0 ? true : false)
                this.nextStatus = (toindex==this.questionIds.length-1 ? true : false)
                if(!toQuestion){// 不存在题目，获取详情
                    this.currIndex = toindex
                    this._getQuestionDetails(this.questionIds[toindex])
                }else{
                    this.currItemInfo = toQuestion
                    this.currIndex = toindex
                }
            }
        },
        next(id, type){
            this.submit(id, type)
        },
        // 提交习题答案
        async submit(id, type, status) {
            let currStatus = false //控制是否允许提交试卷
            this.flag = false
            if(!this.currItemInfo.yourAnswer || this.currItemInfo.yourAnswer　=='undefined'){
                this.$Message.info('请先选择或填写答案')
                this.flag = true
                currStatus = false
                return false
            }else{
                currStatus = true
            }
            if(currStatus && status == 'submitAll'){
                this.showResultModal = true
            } else{
                this.showResultModal = false
            }
            this.isNext = true
            let endTime = Date.parse(new Date())
            let questionStatus
            if(type == 2 && (typeof this.yourAnswer.answer!=='string')){// 多选答案排序对比正确答案
                if(this.currItemInfo.answer == this.yourAnswer.answer.sort().join(',')){
                    questionStatus = 0
                }else{
                    questionStatus = 1
                }
            }
            if( type==4 && (typeof this.yourAnswer.answer!=='string')){// 填空时  yourAnswer为数组
                if(this.currItemInfo.yourAnswer.length !== Number(this.currItemInfo.answerCount)){
                    this.$Message.error('答案与规定答案数量不一致')
                    this.flag = true
                    return false
                }
                if(this.currItemInfo.answer == this.yourAnswer.answer.join(',')){
                    questionStatus = 0
                }else{
                    questionStatus = 1
                }
            }
            if(type==3){
                if(this.currItemInfo.answer=='对'){
                    this.currItemInfo.answer = 'A'
                }else{
                    this.currItemInfo.answer = 'B'
                }
            }
            if(this.currItemInfo.answer==this.yourAnswer.answer){
                questionStatus = 0
            }else{
                questionStatus = 1
            }
            let params = {
                userId: this.userInfo.id,
                userName: this.userInfo.username,
                questionId: this.currQuestionId || '',
                questionStatus: questionStatus,
                costTime: endTime - this.startTime,
                yourAnswer: this.yourAnswer.answer,
                batchId: this.batchId,
            }
            util.md5Encryption(params)
            const res = await this.postTKRequest('/v1/saveQuestionAnswer', params, true)
            if(res.success){
                this.startTime = Date.parse(new Date())
            }
            this.prevStatus = false
            let index = this.questionIds.findIndex((value, index, arr) => {
                return value === id
            })
            this.currIndex = index + 1
            if( this.questionIds[index+1]){
                this.currQuestionId = this.questionIds[index+1]
                this._getQuestionDetails(this.currQuestionId)
            }
            if(!this.questionIds[index+2]) {
                this.nextStatus = true
            }
        },
        handleEndTest(){
            this.$refs.child.$emit('childEndCount')
        },
        parentFn(childTimeInfo){
            this.submit(this.currQuestionId, this.currItemInfo.questionType, 'submitAll')
            this.childTimeInfo = childTimeInfo
            this.timeSpend = (childTimeInfo.hour!=='00' ? childTimeInfo.hour + '小时' : '') + (childTimeInfo.minite!=='00' ? childTimeInfo.minite + '分钟' : '') + (childTimeInfo.second!=='00' ? childTimeInfo.second + '秒' : '')
            let rightArr = this.quesAnswerList.filter((item)=>{
                return item.rightStatus == '1'
            })
            this.rightCounts = rightArr.length
            this.rightRate = parseInt((rightArr.length/this.questionIds.length)*100) +'%'
            this.modalShow = false
            
            
        },
        offResultModal(){
            this.showResultModal = false
            this.$router.push({name:'knowledgeStrong'})
        },
  },
}
</script>
<style lang="less" scoped>
.card{
    position: relative;
    /deep/ .ivu-card-body{
        min-height: 600px;
        .count{
            position: absolute;
            left: 50%;
            top: 35px;
            transform: translateX(-50%);
        }
        .item-footer{
            position: absolute;
            bottom: 20px;
            left: 0;
        }
    }
}
/deep/ .ivu-card-body{
    padding: 16px 30px;
}
.activeIndex{
    color: #fff;
    background: #FCB538;
    border-color: #FCB538;
}

.title{
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    border-bottom: 2px solid #eee;
    div:first-child{
        span{
            margin-right: 10px;
        }
    }
    .point{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        max-width: 40%;
        height: 100%;
    }
}
.item-num{
    margin-top: 20px;
    span{
        display: inline-block;
        height: 30px;
        width: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 10px;
        border-radius: 50%;
        border: 1px solid #eee;
        // box-shadow: 2px 2px 2px rgba(0,0,0,.3);
        cursor: pointer;
    }
}

.item-footer{
    width: 20%;
    display: flex;
    margin-left: 60px;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    /deep/ .ivu-btn{
        background-color: #FF9D00;
        color: #fff;
        border: none;
        outline: none;
    }
}
.item-detail{
    margin:20px 0;
    overflow: hidden;
    padding: 0 20px;
    
}
.resultModal{
    /deep/ .ivu-modal-footer{
        display: none;
    }
    .re-title{
        width: 100%;
        text-align: center;
        font-weight: 700;
        font-size: 20px;
    }
    .re-counts{
        width: 400px;
        display: flex;
        justify-content: space-between;
        height: 70px;
        align-items: center;
    }
    .re-num{
        span{
            padding: 5px 10px;
            margin-right: 10px;
            border-radius: 4px;
            border: 1px solid #eee;
            cursor: pointer;
        }
    }
    .right-rate{
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px 20px;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #FF9D00;
        color: #fff;
        border-radius:0 6px 0 6px;
        font-size: 12px;
        div:nth-child(2){
            font-size: 26px;
        }
    }
    .re-spend{
        margin: 20px 0;
    }
    .right-key{
        background-color: #eee;
        padding: 20px;
        display: inline-flex;
        width: 100%;
        justify-content: space-between;
        border-radius: 6px;
        span:last-child{
            cursor: pointer;
        }
    }
    .re-resolution{
        padding: 10px;
        /deep/ img{
            max-width: 100%;
        }
        /deep/ video{
            max-width: 100%;
        }
    }
}
/deep/ .ivu-spin{
    height: 400px;
    .ivu-spin-main{
        height: 100%;
        display: inline-flex;
        align-items: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/practise/knowledgeStrongPractise.vue